// src/pages/AdminUsersPage.jsx
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Card,
  TextField,
  Button,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Alert,
  CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Delete, Visibility, VisibilityOff, ArrowBack } from '@mui/icons-material';

const AdminUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const fetchUsers = async () => {
    const res = await fetch('https://triunityiq.com/api.php/get-users');
    const data = await res.json();
    if (data.status === 1) setUsers(data.users);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleAdd = async () => {
    if (!form.username || !form.password) {
      setMsg({ type: 'error', text: 'Username and password required.' });
      return;
    }
    setLoading(true);
    const res = await fetch('https://triunityiq.com/api.php/add-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    const data = await res.json();
    setLoading(false);
    if (data.status === 1) {
      setMsg({ type: 'success', text: 'User added successfully.' });
      setForm({ username: '', password: '' });
      fetchUsers();
    } else {
      setMsg({ type: 'error', text: data.msg || 'Failed to add user.' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    const res = await fetch(`https://triunityiq.com/api.php/delete-user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
    });
    const data = await res.json();
    if (data.status === 1) {
      setMsg({ type: 'success', text: 'User deleted.' });
      fetchUsers();
    } else {
      setMsg({ type: 'error', text: 'Failed to delete user.' });
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
    <Button
      variant="outlined"
      color="primary"
      startIcon={<ArrowBack />}
      component={Link}
      to="/"
    >
      Go to Dashboard
    </Button>
  </Box>
      <Typography variant="h5" color="primary" gutterBottom>
        Admin - User Management
      </Typography>

      <Card sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>Add New User</Typography>
        <Box display="flex" gap={2} mb={2}>
          <TextField
            label="Username"
            name="username"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            fullWidth
          />
          <TextField
            label="Password"
            name="password"
            type={showPwd ? 'text' : 'password'}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            fullWidth
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowPwd(!showPwd)}>
                  {showPwd ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <Button
            variant="contained"
            onClick={handleAdd}
            disabled={loading}
            sx={{ minWidth: 120 }}
          >
            {loading ? <CircularProgress size={24} /> : 'Add'}
          </Button>
        </Box>
        {msg && <Alert severity={msg.type}>{msg.text}</Alert>}
      </Card>

      <Card sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>All Users</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.id}>
                <TableCell>{u.id}</TableCell>
                <TableCell>{u.username}</TableCell>
                <TableCell>{u.role}</TableCell>
                <TableCell>
                    {u.role !== 'admin' && u.username !== 'roman' ? (
                        <IconButton color="error" onClick={() => handleDelete(u.id)}>
                        <Delete />
                        </IconButton>
                    ) : (
                        <Typography variant="caption" color="textSecondary">Protected</Typography>
                    )}
                </TableCell>
              </TableRow>
            ))}
            {users.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">No users found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    </Container>
  );
};

export default AdminUsersPage;
